import { useCallback, useContext, useEffect } from 'react';
import { getRandomItem } from '@/modules/gameUtils/random';
import { AudioAutoPlayerContext } from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayerContext';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import { GameAssetsContext } from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';

export default function useAnswerFeedback() {
  const game = useContext(GameLoopContext);
  const { state: assets } = useContext(GameAssetsContext);
  const audioPlayer = useContext(AudioAutoPlayerContext);

  useEffect(() => {
    if (game.state.answersLog?.length) {
      const playFeedbackAudio = async (sound) => {
        await audioPlayer.actions.play(sound);
      };

      const lastAnswer =
        game.state.answersLog[game.state.answersLog.length - 1];
      if (lastAnswer.correct) {
        playFeedbackAudio(getCorrectFeedbackAudio());
      } else {
        playFeedbackAudio(getIncorrectFeedbackAudio());
      }
    }
  }, [game.state.answersLog]);

  const getIncorrectFeedbackAudio = useCallback(() => {
    const incorrectAudios = ['oo', 'oooo'];
    return assets.sounds[getRandomItem(incorrectAudios)].audio;
  }, [assets]);

  const getCorrectFeedbackAudio = useCallback(() => {
    const correctAudios = ['bien', 'muybien', 'bravo', 'perfecto'];
    return assets.sounds[getRandomItem(correctAudios)].audio;
  }, [assets]);
}
